import React from 'react';
import { ReactSortable } from 'react-sortablejs';
import { IDraggableVideoMediafile } from '../types';
import { DraggableListItem } from './DraggableListItem';

import styles from './index.module.scss';
import PreviewItem from './PreviewItem';

export interface DraggableItemListType {
  itemList?: IDraggableVideoMediafile[];
  updateItems?: (items: Array<IDraggableVideoMediafile>) => void;
  onSetDuration: (id: string, duration: number) => void;
  onRemoveMediafile: (id: string) => void;
  onCopyMediafile: (id: string) => void;
  isBlockedDurationEdit?: boolean;
}

const DraggableVideoMediafiesList: React.FC<DraggableItemListType> = ({
  itemList,
  updateItems,
  onSetDuration,
  onRemoveMediafile,
  onCopyMediafile,
  isBlockedDurationEdit,
}) => (
  <ReactSortable<IDraggableVideoMediafile>
    list={itemList}
    handle=".draggable"
    setList={updateItems}>
    {itemList?.map((item) => (
      <DraggableListItem key={item.id}>
        <PreviewItem
          className={styles.content}
          onSetDuration={onSetDuration}
          file={item}
          onRemoveMediafile={onRemoveMediafile}
          onCopyMediafile={onCopyMediafile}
          isBlockedDurationEdit={isBlockedDurationEdit}
        />
      </DraggableListItem>
    ))}
  </ReactSortable>
);

export default DraggableVideoMediafiesList;
